import { createSelector } from 'reselect'

const getZipwhipSettingsOptions: SelectOptionsSelector = (state) =>
  state.zipwhipSettings.zipwhipSettingsForOptions.map((item) => ({
    id: item.id,
    name: item.name
  })) || ([] as SelectOption[])

export const zipwhipSettingsSelectOptionsSelector: SelectOptionsSelector = createSelector(getZipwhipSettingsOptions, (options) => options)
